import { common } from '../common';
import { colors } from './audi-colors';
export const audiLightTheme = {
    ...common,
    name: 'Audi Light Theme',
    colors,
};
//# sourceMappingURL=audi-light.theme.js.map